import CounterStyle from '../CounterStyle';
const lowerRoman = CounterStyle.additive({
    1000: 'm',
    900: 'cm',
    500: 'd',
    400: 'cd',
    100: 'c',
    90: 'xc',
    50: 'l',
    40: 'xl',
    10: 'x',
    9: 'ix',
    5: 'v',
    4: 'iv',
    1: 'i'
}).withRange(1, 3999);
export default lowerRoman;
//# sourceMappingURL=lowerRoman.js.map